import { TextField } from 'apps/builder/components/settings/modal/fields/TextField'
import { DateField } from 'apps/builder/components/settings/modal/fields/DateField'
import { SignatureField } from 'apps/builder/components/settings/modal/fields/SignatureField'
import { CheckboxField } from 'apps/builder/components/settings/modal/fields/CheckboxField'
import { StaticTextField } from 'apps/builder/components/settings/modal/fields/StaticText'
import { DrawingField } from 'apps/builder/components/settings/modal/fields/DrawingField'
import { LinkField } from 'apps/builder/components/settings/modal/fields/LinkField'
import { BarcodeField } from 'apps/builder/components/settings/modal/fields/BarcodeField'
import { MultiChoiceField } from 'apps/builder/components/settings/modal/fields/MultiChoiceField'
import { SingleChoiceField } from 'apps/builder/components/settings/modal/fields/SingleChoiceField'
import { PassFailField } from 'apps/builder/components/settings/modal/fields/PassFailField'
import { TimeField } from 'apps/builder/components/settings/modal/fields/TimeField'
import { GPSField } from 'apps/builder/components/settings/modal/fields/GPSField'
import { PhotoField } from 'apps/builder/components/settings/modal/fields/PhotoField'
import { RatingField } from 'apps/builder/components/settings/modal/fields/RatingField'
import { CalculationField } from 'apps/builder/components/settings/modal/fields/CalculationField'
import { MirrorField } from 'apps/builder/components/settings/modal/fields/MirrorField'
import { NumberSettings } from 'apps/builder/components/settings/modal/fields/NumberSettings'
import { PaymentField } from 'apps/builder/components/settings/modal/fields/PaymentField'
import { VideoField } from 'apps/builder/components/settings/modal/fields/VideoField'
import { StaticImageField } from 'apps/builder/components/settings/modal/fields/StaticImageField'
import { AttachmentField } from 'apps/builder/components/settings/modal/fields/AttachmentField'
import { DropdownField } from 'apps/builder/components/settings/modal/fields/DropdownField'

export const getSettingsPanel = type => {
  const DefaultSettings = TextField

  const typeSettings = {
    Text: TextField,
    'Long Text': TextField,
    Signature: SignatureField,
    Number: NumberSettings,
    Date: DateField,
    Checkbox: CheckboxField,
    'Static Text': StaticTextField,
    Drawing: DrawingField,
    Link: LinkField,
    Barcode: BarcodeField,
    'Multiple Choice': MultiChoiceField,
    'Single Choice': SingleChoiceField,
    'Pass/Fail': PassFailField,
    Time: TimeField,
    GPS: GPSField,
    Photo: PhotoField,
    Rating: RatingField,
    Calculation: CalculationField,
    Sum: CalculationField,
    Mirror: MirrorField,
    Payment: PaymentField,
    Video: VideoField,
    'Static Image': StaticImageField,
    Attachment: AttachmentField,
    Dropdown: DropdownField,
  }

  return typeSettings[type] || DefaultSettings
}
